const API_URL = 'http://your-backend-api.com';
const getHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('adminToken')}`,
});

export const loginAdmin = async ({ username }) => {
  return new Promise((resolve) => {
    setTimeout(() => { // Simulate network delay
      // Accept any username, no password check
      resolve({ token: `mock-admin-token-${username}` });
    }, 500);
  });
};

export const getClients = async () => {
  const response = await fetch(`${API_URL}/admin/clients`, { headers: getHeaders() });
  return response.json();
};

export const addClient = async (clientData) => {
  const response = await fetch(`${API_URL}/admin/clients`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(clientData),
  });
  return response.json();
};

export const updateClient = async (clientId, clientData) => {
  const response = await fetch(`${API_URL}/admin/clients/${clientId}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(clientData),
  });
  return response.json();
};

export const deleteClient = async (clientId) => {
  const response = await fetch(`${API_URL}/admin/clients/${clientId}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return response.json();
};

export const approveRequest = async (requestId) => {
  const response = await fetch(`${API_URL}/admin/requests/${requestId}/approve`, {
    method: 'PUT',
    headers: getHeaders(),
  });
  return response.json();
};

export const rejectRequest = async (requestId) => {
  const response = await fetch(`${API_URL}/admin/requests/${requestId}/reject`, {
    method: 'PUT',
    headers: getHeaders(),
  });
  return response.json();
};

export const getAllProjects = async () => {
  const response = await fetch(`${API_URL}/admin/projects`, { headers: getHeaders() });
  return response.json();
};

export const addProject = async (projectData) => {
  const response = await fetch(`${API_URL}/admin/projects`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(projectData),
  });
  return response.json();
};

export const updateProject = async (projectId, projectData) => {
  const response = await fetch(`${API_URL}/admin/projects/${projectId}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(projectData),
  });
  return response.json();
};

export const deleteProject = async (projectId) => {
  const response = await fetch(`${API_URL}/admin/projects/${projectId}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return response.json();
};

export const getAllPayments = async () => {
  const response = await fetch(`${API_URL}/admin/payments`, { headers: getHeaders() });
  return response.json();
};

export const addPayment = async (paymentData) => {
  const response = await fetch(`${API_URL}/admin/payments`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(paymentData),
  });
  return response.json();
};

export const updatePayment = async (paymentId, paymentData) => {
  const response = await fetch(`${API_URL}/admin/payments/${paymentId}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(paymentData),
  });
  return response.json();
};

export const deletePayment = async (paymentId) => {
  const response = await fetch(`${API_URL}/admin/payments/${paymentId}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return response.json();
};

export const getAllEvents = async () => {
  const response = await fetch(`${API_URL}/admin/events`, { headers: getHeaders() });
  return response.json();
};

export const addEvent = async (eventData) => {
  const response = await fetch(`${API_URL}/admin/events`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(eventData),
  });
  return response.json();
};

export const updateEvent = async (eventId, eventData) => {
  const response = await fetch(`${API_URL}/admin/events/${eventId}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(eventData),
  });
  return response.json();
};

export const deleteEvent = async (eventId) => {
  const response = await fetch(`${API_URL}/admin/events/${eventId}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return response.json();
};

export const bulkDeleteEvents = async (eventIds) => {
  const response = await fetch(`${API_URL}/admin/events/bulk`, {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify({ ids: eventIds }),
  });
  return response.json();
};

export const getAllNotifications = async () => {
  const response = await fetch(`${API_URL}/admin/notifications`, { headers: getHeaders() });
  return response.json();
};

export const sendNotification = async (notificationData) => {
  const response = await fetch(`${API_URL}/admin/notifications`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(notificationData),
  });
  return response.json();
};

export const updateNotification = async (notificationId, notificationData) => {
  const response = await fetch(`${API_URL}/admin/notifications/${notificationId}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(notificationData),
  });
  return response.json();
};

export const deleteNotification = async (notificationId) => {
  const response = await fetch(`${API_URL}/admin/notifications/${notificationId}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return response.json();
};

export const getAllChats = async () => {
  const response = await fetch(`${API_URL}/admin/chats`, { headers: getHeaders() });
  return response.json();
};

export const sendAdminMessage = async (chatId, messageData) => {
  const response = await fetch(`${API_URL}/admin/chats/${chatId}/messages`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(messageData),
  });
  return response.json();
};

export const closeChat = async (chatId) => {
  const response = await fetch(`${API_URL}/admin/chats/${chatId}/close`, {
    method: 'PUT',
    headers: getHeaders(),
  });
  return response.json();
};

export const getReports = async (type) => {
  const response = await fetch(`${API_URL}/admin/reports/${type}`, { headers: getHeaders() });
  return response.json();
};

export const getServices = async () => {
  const response = await fetch(`${API_URL}/admin/services`, { headers: getHeaders() });
  return response.json();
};

export const addService = async (serviceData) => {
  const response = await fetch(`${API_URL}/admin/services`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(serviceData),
  });
  return response.json();
};

export const updateService = async (serviceId, serviceData) => {
  const response = await fetch(`${API_URL}/admin/services/${serviceId}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(serviceData),
  });
  return response.json();
};

export const deleteService = async (serviceId) => {
  const response = await fetch(`${API_URL}/admin/services/${serviceId}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return response.json();
};

export const getAdmins = async () => {
  const response = await fetch(`${API_URL}/admin/users`, { headers: getHeaders() });
  return response.json();
};

export const addAdmin = async (adminData) => {
  const response = await fetch(`${API_URL}/admin/users`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(adminData),
  });
  return response.json();
};

export const updateAdmin = async (adminId, adminData) => {
  const response = await fetch(`${API_URL}/admin/users/${adminId}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(adminData),
  });
  return response.json();
};

export const deleteAdmin = async (adminId) => {
  const response = await fetch(`${API_URL}/admin/users/${adminId}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return response.json();
};

export const getDashboardStats = async () => {
  const response = await fetch(`${API_URL}/admin/dashboard/stats`, { headers: getHeaders() });
  return response.json();
};